module.exports = __webpack_public_path__ + "media/mypage/images/guys-background-ee88059e11d5a54c666bbf8b104d5540.jpg";